// Analytics configuration for different environments
const getEnvironmentConfig = () => {
    const hostname = window.location.hostname;

    // Determine environment based on hostname
    const isDevelopment =
        hostname === 'dev.tlyfe.co.uk' ||
        hostname === 'localhost' ||
        hostname.includes('192.168.') ||
        hostname.includes('127.0.0.1');

    const isProduction = hostname === 'tlyfe.co.uk';

    return {
        isDevelopment,
        isProduction,
        // TODO: Replace these with your actual GA4 measurement IDs
        measurementId: isDevelopment
            ? 'G-ZMTT19MJL4'      // Replace with your DEV measurement ID
            : 'G-G3S5LQDKDB',    // Replace with your PRODUCTION measurement ID
        debugMode: isDevelopment,
        environment: isDevelopment ? 'development' : 'production'
    };
};

export default getEnvironmentConfig;